module.exports = __webpack_public_path__ + "img/b_Biofer_left.fca2ab96.jpeg";